export default __webpack_public_path__ + "static/media/taraftarplusgift.27fb9497.png";